/**
 * Creates a throttled version of a function that will only execute at most once every `delay` milliseconds.
 *
 * @param {Function} func - The function to throttle.
 * @param {number} delay - The number of milliseconds to wait before allowing the function to be called again.
 * @returns {Function} A new throttled version of the function.
 *
 * @example
 * function logMessage() {
 *   console.log('Throttled function executed');
 * }
 *
 * const throttledLogMessage = throttle(logMessage, 1000);
 *
 * window.addEventListener('resize', throttledLogMessage);
 */
export function throttle(func, delay) {
  if (delay < 0) throw new Error('Delay should be positive')

  let lastCall = 0

  return function (...args) {
    const now = new Date().getTime()
    if (now - lastCall < delay) {
      return
    }
    lastCall = now
    return func.apply(this, args)
  }
}
